const channels = [
  {
    icon: "ri-restaurant-2-line",
    name: "食品安全",
    desc: "注胶、掺假、添加剂等食品类谣言高发区，重点核实来源与属地通报。",
    tone: "bg-primary-50 text-primary-700",
  },
  {
    icon: "ri-heart-pulse-line",
    name: "医疗健康",
    desc: "健康科普与偏方传言，按医学共识与权威指南给可信度分级。",
    tone: "bg-secondary-100 text-secondary-900",
  },
  {
    icon: "ri-shopping-cart-2-line",
    name: "消费电商",
    desc: "直播带货、测评榜单与价格宣传，核对货源、链路与比价依据。",
    tone: "bg-primary-100 text-primary-800",
  },
  {
    icon: "ri-government-line",
    name: "政策法规",
    desc: "民生政策与办事规则误读，以官方文件与解读口径为准。",
    tone: "bg-accent-100 text-accent-800",
  },
  {
    icon: "ri-movie-2-line",
    name: "娱乐圈",
    desc: "绯闻与职场爆料，区分匿名截图与可查证的公开记录。",
    tone: "bg-accent-50 text-accent-700",
  },
  {
    icon: "ri-earth-line",
    name: "社会热点",
    desc: "突发事件与公共议题中的现场信息，强调多方信源交叉。",
    tone: "bg-secondary-200 text-secondary-900",
  },
  {
    icon: "ri-briefcase-4-line",
    name: "商界争议",
    desc: "公司经营与品牌翻车消息，回溯公告、财报与公开披露。",
    tone: "bg-primary-100 text-primary-800",
  },
];

export default function Channels() {
  return (
    <section id="categories" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-secondary-600">
              Focus Channels
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[2rem]">
              关注栏目：按领域分类求证
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              不同领域的传闻，判断标准各有侧重。选择你最关心的栏目，查看该领域的最新求证结果。
            </p>
          </div>
          <a
            href="#latest"
            className="inline-flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            进入求证榜单
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {channels.map((c) => (
            <a
              key={c.name}
              href="#latest"
              className="group flex flex-col rounded-xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className={`flex h-11 w-11 items-center justify-center rounded-lg text-xl ${c.tone}`}>
                  <i className={c.icon} aria-hidden="true"></i>
                </span>
                <i
                  className="ri-arrow-right-up-line text-lg text-background-300 transition-all group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-primary-500"
                  aria-hidden="true"
                ></i>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{c.desc}</p>
            </a>
          ))}

          <a
            href="#contact"
            className="group flex flex-col items-start justify-center rounded-xl border border-dashed border-primary-300 bg-primary-50/50 p-5 transition-colors hover:bg-primary-100/70"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-600 text-xl text-background-50">
              <i className="ri-megaphone-line" aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 font-heading text-lg font-bold text-primary-800">没有你要的栏目？</h3>
            <p className="mt-2 text-[13px] leading-relaxed text-foreground-700">
              把你正在关注的争议事件交给我们，纳入下一步核实范围。
            </p>
            <span className="mt-3 inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-700">
              提交新线索
              <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}